import {AddIcon} from "@chakra-ui/icons";
import {
  Button,
  FormControl, FormHelperText, FormLabel,
  Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay,
  useDisclosure, useToast,
} from "@chakra-ui/react";
import React, {useState} from "react";
import {useMutation, useQueryClient} from "react-query";

import {
  downloadCertificatesExcel,
} from "../../shared/Api";
import {errorToast, successToast} from "../../shared/helper/ToastHelper";
import { adminKeys } from "../../shared/QueryKeys";
import { saveByteArray} from "../../shared/Utils";

type CreateCertificatesProps = {
  onFileSent: (file: File) => void;
};
const CreateCertificates = () => {
  const queryClient = useQueryClient();
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [file, setFile] = useState<File | null>(null);

  const downloadCertificatesMutation = useMutation(downloadCertificatesExcel,
    {
    onSuccess: (TData) => {
      successToast(toast, `Descargando`);
      saveByteArray("Certificados", TData.data);
      return queryClient.invalidateQueries(adminKeys.users());
    },
    onError: () => {
      errorToast(toast, "Error descargando");
    },
  });

  function handleChange(e: any) {
    setFile(e.target.files[0]);
  }

  function handleDownloadClick() {
    if (file) {
      downloadCertificatesMutation.mutate(file);
    }
    onClose();
  }

  return (
    <>
      <Button leftIcon={<AddIcon />} colorScheme="teal" onClick={onOpen}>
        Crear Certificados
      </Button>
      <Modal blockScrollOnMount={false} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Nuevos Certificados</ModalHeader>
          <ModalBody>
            <FormControl id="file-form-control" paddingBottom="6">
              <FormLabel>Certificados</FormLabel>
              <input name="file-input" type="file" onChange={handleChange} />
              <FormHelperText>
                Seleccione un archivo en formato xlsx.
              </FormHelperText>
            </FormControl>
          </ModalBody>
          <ModalCloseButton />
          <ModalFooter>
            <Button
              colorScheme="teal"
              type="submit"
              isDisabled={!file}
              onClick={handleDownloadClick}
            >
              Generar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default CreateCertificates;
